import React from 'react';
import CustomLogo from '@/components/CustomLogo/CustomLogo';
import TwoSplitLogo from '@/components/TwoSplitLogo/TwoSplitLogo';
import TwoSplitTaglineLogo from '@/components/TwoSplitLogo/TwoSplitTaglineLogo';
import CustomLogoHorizontal from '@/components/CustomLogoHorizontal/CustomLogoHorizontal';
import CustomLogoHorizontalTagline from '@/components/CustomLogoHorizontal/CustomLogoHorizontalTagline';
import CustomLogoMobileSize from '@/components/CustomLogoHorizontal/CustomLogoMobileSize';
import CustomSingleLogo from '@/components/CustomSingleLogo/CustomSingleLogo';
interface CustomLogoRendererProps {
  templateName?: string | undefined;
}
const CustomLogoRenderer: React.FC<CustomLogoRendererProps> = ({
  templateName
}) => {
  switch (templateName) {
    case 'two-logo-horz':
      return <CustomLogo />;
    case 'two-split-logo-horz':
      return <TwoSplitLogo />;
    case 'two-split-tagline-dell-microsoft':
      return <TwoSplitTaglineLogo />;
    case 'two-split-tagline-logo-horz':
      return <TwoSplitTaglineLogo />;
    case 'two-logo-horz-dell-stack-intel':
      return <CustomLogoHorizontal />;
    case 'two-logo-horz-dell-intel':
      return <CustomLogoHorizontal />;
    case 'two-logo-horz-dell-intel-tagline':
      return <CustomLogoHorizontalTagline />;
    case 'two-logo-horz-mobile-size':
      return <CustomLogoMobileSize />;
    case 'two-logo-dell-stack-xeon':
      return <CustomLogoMobileSize />;
    case 'single-logo-horz':
      return <CustomSingleLogo />;
    default:
      return <CustomLogo />;
  }
};
export default CustomLogoRenderer;